import { useContext, useEffect, useState } from "react";
import Context from "../../../../context";
import {
  CustomBadges,
  CustomButton2,
  CustomCard,
  CustomIcon,
  CustomInfoCard,
  CustomInput,
  TableHeader,
  TableLoading,
  TableNullData,
} from "../../../../components";
import { IDeterminePriceCategory } from "../../../../types/category.interface";
import values from "../../../../values";
import Container from "../../../../components/CustomView/Container";
import Row from "../../../../components/CustomView/Row";
import Column from "../../../../components/CustomView/Column";
import CustomDropDownSearch from "../../../../components/CustomDropDownSearch";
import { CATEGORY_BASE } from "../../../../values/dropdownItems";
import { IItem } from "../../../../types/common.interface";
import "./index.scss";
import utils from "../../../../utils";

const Body = ({ data }: any) => {
  const {
    resultCategory,
    setSelectedCategory,
    setShowModal,
    setRequestCategory,
    updateCategoryPrice,
  } = useContext(Context.CategoryPriceScreen);
  const [selectedType, setSelectedType] = useState<IItem>(CATEGORY_BASE[0]);

  const [prices, setPrices] = useState<any>(data);

  useEffect(() => {
    setPrices(data);
  }, [data]);

  const onDetail = (categoryPrice: IDeterminePriceCategory) => {
    setSelectedCategory!(categoryPrice);
    setShowModal!("DETAIL");
  };
  const onUpdate = (categoryPrice: IDeterminePriceCategory) => {
    setSelectedCategory!(categoryPrice);
    setShowModal!("UPDATE");
  };
  const onDelete = (categoryPrice: IDeterminePriceCategory) => {
    setSelectedCategory!(categoryPrice);
    setShowModal!("DELETE");
  };

  // combine price and category
  const allCategory = resultCategory?.data?.result?.map((item: any) => {
    return {
      _id: item?._id,
      categoryName: item?.categoryName,
      price: prices?.find((priceItem: any) => priceItem?.category === item?._id)
        ?.price,
    };
  });
  return (
    <>
      <Container className="category-price--main-container">
        <Row>
          <Column medium={4}>{""}</Column>
          <Column medium={4}>
            <label className="form-label">انتخاب نوع دسته بندی</label>
            <CustomDropDownSearch
              items={CATEGORY_BASE}
              itemName="name"
              onSelectItem={(event) => {
                setSelectedType(event);
                setRequestCategory!({ type: event?._id });
              }}
              placeHolder="نوع دسته بندی"
              defaultItem={selectedType}
              nullable={false}
            />
          </Column>
          <Column medium={4}>{""}</Column>
        </Row>
        <Row className="notice">* قیمت ها را به تومان وارد کنید</Row>
        {allCategory?.length <= 0 || !data ? (
          <TableNullData />
        ) : (
          <>
            <Row>
              {resultCategory?.status === "loading" ? (
                <TableLoading />
              ) : (
                <div id="category-price-body-container">
                  <Row className="category-price-container">
                    {allCategory?.map((category: any, index: number) => {
                      return (
                        <Column medium={4} key={`driver-${index}`}>
                          <div className="category-card">
                            <div>{category?.categoryName}</div>

                            <div className="icons-wrapper">
                              <CustomInput
                                placeHolder={"قیمت (تومان)"}
                                defaultValue={utils.convertNumberToPrice(
                                  Number(category?.price)
                                )}
                                value={utils.convertNumberToPrice(
                                  Number(
                                    prices?.find(
                                      (item: any) =>
                                        item?.category === category?._id
                                    )?.price
                                  )
                                )}
                                onValueChange={(event) =>
                                  setPrices((prev: any) => {
                                    const index = prev?.indexOf(
                                      prices?.find(
                                        (item: any) =>
                                          item?.category === category?._id
                                      )
                                    );
                                    const arrayWithRemovedElement = prev;

                                    index >= 0 &&
                                      arrayWithRemovedElement?.splice(index, 1);
                                    const newArray = [
                                      ...arrayWithRemovedElement,
                                      {
                                        category: category._id,
                                        price: event.target.value.replace(
                                          /,/g,
                                          ""
                                        ),
                                      },
                                    ];
                                    return newArray;
                                  })
                                }
                              />
                            </div>
                          </div>
                        </Column>
                      );
                    })}
                  </Row>
                </div>
              )}
            </Row>
            <Row className="form-row button-row">
              <Column medium={5}>{""}</Column>

              <Column medium={2}>
                <CustomButton2
                  title={"ثبت قیمت ها"}
                  type="primary"
                  onClick={() => updateCategoryPrice!(prices)}
                />
              </Column>
              <Column medium={5}>{""}</Column>
            </Row>
          </>
        )}
      </Container>
    </>
  );
};

export default Body;
